/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cosMissatge textarea{height:100%!important}  .form-group{height:100%!important}  mat-form-field{height:100%!important}  .mat-form-field-wrapper{height:100%!important}  .mat-form-field-flex{height:100%!important}  .mat-form-field-infix{height:100%!important}.fixed-height[_ngcontent-%COMP%]{height:50vh;max-height:50vh}.fixed-height-scroll[_ngcontent-%COMP%]{overflow-y:scroll;overflow:auto;border-right:1px solid #000}"];
export { styles as styles };
